import React, { useState } from 'react'
import List from './List'
import AddAMUAgent from './AddAMUAgent/Main'
import AMUAgentMain from './AMUAgentMain'
import '../utils/Ev.scss';
export default function Main({ }) {
    const [tab, setTab] = useState("list")
    const [editData, setEditData] = useState({})

    const handleTab = (data, pageType) => {
        setEditData(data)
        setTab(pageType)
    }
    return (
        <>
            <div className="communitySection" style={{ marginTop: '20px' }}>
                {
                    tab == "list" ?
                        <List handleTab={handleTab} />
                        : ''}

                {
                    tab == "addEditsalesAgent" ?
                        <AddAMUAgent Detaildata={editData} handlePage={handleTab} />
                        : ''
                }
                {
                    tab == "salesAgentDetail" ?
                        <AMUAgentMain Detaildata={editData} handlePage={handleTab} />
                        : ''
                }
            </div>
        </>
    )
}
